import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { ParentGuardianDetails } from '../models/parent-guardian-details';
import { SingleResultApiResponse, ApiResponse } from 'src/app/shared/models/api-response.model';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { Country, Relationship, Tab_Title } from 'src/app/shared/models/lookup-data.model';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DefaultCorrespondent } from '../models/corresondents';
import { compareDefaultCorrespondents } from '../shared/utils/ModelUtils';
import { Observable, forkJoin } from 'rxjs'
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'online-app-parent-guardian-details',
  templateUrl: './parent-guardian-details.component.html',
  styleUrls: ['./parent-guardian-details.component.scss'],
  host: {
    class: 'application-section-component'
  },
})
export class ParentGuardianDetailsComponent implements OnInit {

  parentGuardians: ParentGuardianDetails[] = [];
  countries: Country[];
  relationships: Relationship[];
  applicationId: number;
  parentGuardianIdToBeDeleted: number;
  addContactValidationErrorMessage: string;
  contactsValidationMessage = '';
  showModal = false;
  isSubmittedApplication = false;
  defaultCorrespondentId = 0;
  defaultCorrespondentIsAgent = false;
  currentSetDefaultCorrespondentId = 0;
  initialCorrespondent = null;
  showDeleteReferenceWarningModal: boolean = false;
  isStudyAbroad: boolean = null;
  hasNonParentLegalCustodian: boolean = null;
  isAgentCreatedApplication: boolean = null;

  @ViewChild('resolve') resolve: ElementRef;
  @ViewChild('delete') delete: ElementRef;
  constructor(private router: Router,
    private store: Store<any>,
    private modalService: ModalService,
    private applicationService: ApplicationService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.activatedRoute.parent.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });
  }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_ParentCarerDetails_Title);
    }else{
      this.titleService.setTitle(Tab_Title.ParentCarerDetails_Title);
    }
    this.countries = this.activatedRoute.snapshot.data['countries'];
    this.relationships = this.activatedRoute.snapshot.data['relationshipTypes'];
    this.parentGuardians = this.activatedRoute.snapshot.data['parentGuardianDetails'];
    this.hasNonParentLegalCustodian = this.parentGuardians.some(p => p.HasLegalCustody && p.RelationshipCode !== 'FTH' && p.RelationshipCode !== 'MTH');

    const parentLegalcustodian = this.parentGuardians.filter(p => p.IsParent || p.HasLegalCustody);
    //console.log('parentLegalcustodian list');
    //console.log(parentLegalcustodian);
    const isParentLegalcustodianValid = parentLegalcustodian.length >= 1 && parentLegalcustodian.every(p => p.IsValid);
    //console.log('isParentLegalcustodianValid result');
    //console.log(isParentLegalcustodianValid);

    if (this.hasNonParentLegalCustodian) {
      const lcIndex = this.parentGuardians.findIndex(x => x.HasLegalCustody);

      const lc = this.parentGuardians.splice(lcIndex, 1);

      this.parentGuardians.unshift(lc[0]);
    }

    if (!isParentLegalcustodianValid) {
      this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details', 'parent-legalcustodian']);
    }

    this.modalService.allowDelete.subscribe(allowDelete => {
      if (allowDelete) {
        if (this.parentGuardianIdToBeDeleted && this.parentGuardianIdToBeDeleted > 0) {
          this.applicationService.deleteParentGuardianDetails(this.applicationId, this.parentGuardianIdToBeDeleted)
            .subscribe(response => {
              this.parentGuardianIdToBeDeleted = 0;
              //console.log('parent guardian deleted and set parentGuardianIdToBeDeleted to zero');
              this.getParentGuardiansDetails();
              this.dispatchSectionSaveAction();
            }, err => {
              //console.error(err);
            });
        }
      } else {
        this.parentGuardianIdToBeDeleted = 0;
      }
    });


    let observableBatch = [];
    observableBatch.push(this.applicationService.getApplicationDetails(this.applicationId));
    observableBatch.push(this.applicationService.getSchoolProgramAndPlacementDetails(this.applicationId));

    let observable: Observable<any> = forkJoin(observableBatch);
    observable.subscribe(
      data => {

        this.isAgentCreatedApplication = data[0].Result.AgencyOrBranchId !== null;
        //console.log("--- is agent created this app?---", this.isAgentCreatedApplication);

        this.isSubmittedApplication = data[0].Result.ApplicationStatus === 'Submitted';

        this.isStudyAbroad = data[1].Result.SchoolProgramType === 'StudyAbroad';

        this.initAndSetDefaultCorrespondentDetails();

      }, (errorResponse: ErrorResponse) => { });
  }


  initAndSetDefaultCorrespondentDetails() {

    if (this.parentGuardians && this.parentGuardians.length) {

      //e.g. in SchoolProgram page, after user select programtype and save, actually we already save IsAgentDefaultCorrespondence value
      var defaultCorrespondent = this.parentGuardians.find(c => c.IsDefaultCorrespondent);
      if (defaultCorrespondent) {
        this.defaultCorrespondentId = defaultCorrespondent.ParentGuardianId;
        this.defaultCorrespondentIsAgent = defaultCorrespondent.RelationshipCode === 'AGENT';
      }
      else {
        this.defaultCorrespondentId = 0;
        //if ISP, Agent cannot be default correspondant
        //if StudyAbroad, only Agebt can be
        if (this.isStudyAbroad && this.isAgentCreatedApplication)
          this.defaultCorrespondentIsAgent = true;
        else
          this.defaultCorrespondentIsAgent = false;
      }

    }

    if (!this.initialCorrespondent) {
      this.initialCorrespondent = new DefaultCorrespondent();
    }
    this.initialCorrespondent.CorrespondentId = this.defaultCorrespondentId;
    this.initialCorrespondent.IsAgent = this.defaultCorrespondentIsAgent;
  }


  isCurrentDefaultCorrespondent(parentGuardian): boolean {
    if (this.defaultCorrespondentIsAgent) {
      return parentGuardian.RelationshipCode === 'AGENT'; //parentGuardian.ParentGuardianId === this.defaultCorrespondentId &&
    } else {
      return parentGuardian.RelationshipCode !== 'AGENT' && parentGuardian.ParentGuardianId === this.defaultCorrespondentId;
    }
  }



  isShowTickDefaultCorrespindent(parentGuardian): boolean {

    if (this.defaultCorrespondentIsAgent) {
      return parentGuardian.RelationshipCode === 'AGENT';
    }
    else {
      return parentGuardian.RelationshipCode !== 'AGENT' && !parentGuardian.IsDeceased
        && !this.failAdditionalCheck(parentGuardian);
    }
  }

  failAdditionalCheck(parentGuardian): boolean {
    //const isParentOrLegalCustodian : boolean = this.isParentOrLegalcustodian(parentGuardian);
    //if (isParentOrLegalCustodian === false) {
    //  // to show default correspondent checkbox
    //  //enable tick
    //}

    //if there is legal custodian other than parents, then hide checkbox for parents
    return this.hasNonParentLegalCustodian && (parentGuardian.RelationshipCode === 'FTH' || parentGuardian.RelationshipCode === 'MTH');
  }



  getParentGuardiansDetails(): void {
    this.applicationService.getParentGuardiansDetails(this.applicationId)
      .subscribe((response: ApiResponse) => {
        //console.log('got parent guardian details');
        this.parentGuardians = <ParentGuardianDetails[]>response.Result;
        this.initAndSetDefaultCorrespondentDetails();
      }, err => {
        //console.error(err);
      });
  }

  getRelationshipTypeDescription(relationshipTypeCode: string): string {
    const relationship = this.relationships.filter(reln => reln.Code === relationshipTypeCode)[0];
    return relationship ? relationship.Description : '';
  }

  getParentCarerDescription(parentGuardianDetails: ParentGuardianDetails) {
    const relationshipTypeDescription = this.getRelationshipTypeDescription(parentGuardianDetails.RelationshipCode);
    const isLegalCustodian = !parentGuardianDetails.IsParent && parentGuardianDetails.HasLegalCustody;
    const otherRelationship = isLegalCustodian && parentGuardianDetails.RelationshipCode === 'OTH' ? parentGuardianDetails.OtherRelationship : '';
    const isParentWithNoCustody = parentGuardianDetails.IsParent && !parentGuardianDetails.HasLegalCustody;
    const legalCustodian = 'Legal Custodian';
    const deceased = 'Deceased';

    const familyName = parentGuardianDetails.FamilyName ? parentGuardianDetails.FamilyName : '';
    const givenName = parentGuardianDetails.GivenName ? parentGuardianDetails.GivenName : '';
    const fullName = familyName === '' ? givenName : `${familyName}, ${givenName}`;

    let contactTitle = '';
    if (isLegalCustodian) {
      if (!!otherRelationship) {
        contactTitle = `${relationshipTypeDescription} - ${legalCustodian} (${otherRelationship}) - ${fullName}`;
      } else {        
        contactTitle = `${relationshipTypeDescription} - ${legalCustodian} - ${fullName}`;
      }
    } else if (parentGuardianDetails.IsDeceased) {
      contactTitle = `${relationshipTypeDescription} - ${deceased} - ${fullName}`;
    } else {
      if (isParentWithNoCustody) {
        contactTitle = `${relationshipTypeDescription} (No custody) - ${fullName}`;
      } else {
        contactTitle = `${relationshipTypeDescription} - ${fullName}`;
      }
    }
    return contactTitle;
  }

  isParentCarerEmailAvailable(parentGuardianDetails: ParentGuardianDetails): boolean {
    if (parentGuardianDetails) {
      return parentGuardianDetails.EmailAddress !== null && parentGuardianDetails.EmailAddress !== '';
    }
    return false;
  }

  getParentCarerEmail(parentGuardianDetails: ParentGuardianDetails) {
    return this.isParentCarerEmailAvailable(parentGuardianDetails) === true ? parentGuardianDetails.EmailAddress : 'Not available';
  }

  getParentCarerMobilePhone(dtls: ParentGuardianDetails) {
    let phone = 'Not available';
    if (dtls) {
      if (dtls.MobileCountryCode != null && dtls.MobilePhoneNumber != null) {
        phone = '+' + dtls.MobileCountryCode + ' ' + dtls.MobilePhoneNumber;
      } else if (dtls.HomeCountryCode != null && dtls.HomePhoneNumber != null) {
        phone = '+' + dtls.HomeCountryCode + ' ' + dtls.HomePhoneNumber;
      } else if (dtls.MobileCountryCode == null && dtls.MobilePhoneNumber != null) {
        phone = dtls.MobilePhoneNumber;
      }
    }
    return phone;
  }

  getParentCarerCurrentAddress(addr: ParentGuardianDetails) {
    let currentAddress = '';
    if (addr) {
      if (addr.IsOverseasAddressCurrentAddress === true) {
        let addressLine1 = !addr.OverseasAddressLine1 ? '' : addr.OverseasAddressLine1;
        let addressLine2 = !addr.OverseasAddressLine2 ? '' : ', ' + addr.OverseasAddressLine2;
        let suburb = !addr.OverseasSuburbTown ? '' : ', ' + addr.OverseasSuburbTown;
        let state = !addr.OverseasStateProvinceRegion ? '' : ', ' + addr.OverseasStateProvinceRegion;
        let postcode = !addr.OverseasPostcode ? '' : ', ' + addr.OverseasPostcode;
        const countryName = this.getCountryNameById(addr.OverseasCountryId);
        let country = !countryName ? '' : ', ' + countryName;
        currentAddress = addressLine1 + addressLine2 + suburb + state + postcode + country;
      } else if (addr.IsAustralianAddressCurrentAddress === true) {
        let addressLine1 = !addr.AustralianAddressLine1 ? '' : addr.AustralianAddressLine1;
        let addressLine2 = !addr.AustralianAddressLine2 ? '' : ', ' + addr.AustralianAddressLine2;
        let suburb = !addr.AustralianSuburb ? '' : ', ' + addr.AustralianSuburb;
        let state = !addr.AustralianState ? '' : ', ' + addr.AustralianState;
        let postcode = !addr.AustralianPostcode ? '' : ', ' + addr.AustralianPostcode;
        const country = 'Australia';
        currentAddress = addressLine1 + addressLine2 + suburb + state + postcode + country;
      }
    }
    return currentAddress ? currentAddress : 'Not available';
  }

  getCountryNameById(countryId: string) {
    const country = this.countries.find(c => c.Id === countryId);

    return country ? country.Description : '';
  }


  setDefaultCorrespondent(parentGuardian: any) {
    if (!parentGuardian)
      return;

    if (parentGuardian.IsCorrespondentSelectionDisabled || this.isSubmittedApplication)
      return;

    const defaultCorrespondentToSave = new DefaultCorrespondent();

    defaultCorrespondentToSave.CorrespondentId = parentGuardian.ParentGuardianId;
    defaultCorrespondentToSave.IsAgent = parentGuardian.RelationshipCode === 'AGENT';

    if (!parentGuardian.IsDefaultCorrespondent) {
      parentGuardian.IsDefaultCorrespondent = true;
    }

    this.applicationService.setDefaultCorrespondent(this.applicationId, defaultCorrespondentToSave)
      .subscribe((response: SingleResultApiResponse) => {
        this.dispatchSectionSaveAction();

        this.defaultCorrespondentId = parentGuardian.ParentGuardianId;
        this.defaultCorrespondentIsAgent = parentGuardian.RelationshipCode === 'AGENT';

      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        for (const error of errors) {
          //console.log(`Error in updating Default correspondent details.${error.Key},${error.Value}`);
        }
        this.dispatchSectionSaveAction();
      });
  }

  isDefaultCorrespondentDetailsSame(): boolean {
    const currentDefaultCorrespondent = new DefaultCorrespondent();
    currentDefaultCorrespondent.CorrespondentId = this.initialCorrespondent;
    currentDefaultCorrespondent.IsAgent = this.defaultCorrespondentIsAgent;

    const initialDefaultCorrespondent = this.initialCorrespondent;

    const isDefaultCorrespondentDetailsSame =
      compareDefaultCorrespondents(initialDefaultCorrespondent, currentDefaultCorrespondent);

    return isDefaultCorrespondentDetailsSame;
  }


  isFatherOrMotherExists(): boolean {
    const parentGuardian = this.parentGuardians.find(p => p.RelationshipCode === 'MTH' || p.RelationshipCode === 'FTH');

    if (parentGuardian) {
      return true;
    }

    return false;
  }

  addParentGuardian(): void {
    this.applicationService.validateAddContact(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details', '0', 'edit']);
        }
      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        for (const error of errors) {
          if (error.Key === 'AddContactValidation') {
            this.addContactValidationErrorMessage = error.Value;
          }
        }
        this.modalService.showAllowAddContactModal();
      });
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'school-program-placement']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'accommodation-welfare']);
  }

  continue(): void {
    this.applicationService.validateContacts(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'accommodation-welfare']);
        }
      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        for (const error of errors) {
          if (error.Key === 'ContactsValidation') {
            this.contactsValidationMessage = error.Value;
            this.showModal = true;
            setTimeout(() => {
              this.resolve.nativeElement.focus();
            }, 100);
          }
        }
      });

  }

  displayModal(): boolean {
    return this.contactsValidationMessage && this.contactsValidationMessage.length > 0 && this.showModal;
  }

  clickOK() {
    this.showModal = false;
  }

  displayDeleteReferencesModal(): boolean {
    return this.showDeleteReferenceWarningModal;
  }

  cancelDeleteReferences() {
    this.showDeleteReferenceWarningModal = false;
  }

  deleteParentGuardianWithReferences() {
    this.showDeleteReferenceWarningModal = false;
    if (this.parentGuardianIdToBeDeleted && this.parentGuardianIdToBeDeleted > 0) {

      this.applicationService.deleteParentGuardianDetails(this.applicationId, this.parentGuardianIdToBeDeleted)
        .subscribe(response => {
          this.parentGuardianIdToBeDeleted = 0;
          this.getParentGuardiansDetails();
          this.dispatchSectionSaveAction();
        }, err => {
          //console.log('error while deleting..');
          console.error(err);
        });

    }
  }


  editParentGuardian(parentGuardianId: number) {
    //console.log('editParentGuardian - parentGuardianId');
    //console.log(parentGuardianId);

    this.applicationService.IsParentOrLegalcustodian(this.applicationId, parentGuardianId)
      .subscribe((response: SingleResultApiResponse) => {
        //console.log('IsParentOrLegalcustodian - response');
        //console.log(response);
        if (response.Result) {
          if (response.Result.IsParentOrLegalcustodian.Result) {
            this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details', 'parent-legalcustodian']);
          } else {
            this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details', parentGuardianId, 'edit']);
          }
        }
      }, (errorResponse: ErrorResponse) => {
        //'IsParentOrLegalcustodian - Error');
        console.log(errorResponse);
      });
  }


  deleteParentGuardian(parentGuardianId: number) {

    this.parentGuardianIdToBeDeleted = parentGuardianId;
    this.applicationService.getParentGuardianReferences(this.applicationId, parentGuardianId).subscribe
      (
        (response: SingleResultApiResponse) => {
          if (response.Result) {
            this.showDeleteReferenceWarningModal = response.Result.IsSelectedCarer || response.Result.IsDefaultCorrespondent;

            if (this.showDeleteReferenceWarningModal === false) {
              this.modalService.showDeleteModal();
            } else {
              setTimeout(() => {
                this.delete.nativeElement.focus();
              }, 100);
            }
          }
        }, (errorResponse: ErrorResponse) => {
          const { errors } = errorResponse;
          console.log(errors);
        }
      );

  }

  isParentOrLegalcustodian(parentGuardian: ParentGuardianDetails) {
    //console.log('isParentOrLegalcustodian - parentGuardian', parentGuardian);
    return parentGuardian.RelationshipCode === "FTH" || parentGuardian.RelationshipCode === "MTH" || parentGuardian.HasLegalCustody;
  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }



  shouldDisableOrNot(parentGuardian): boolean {
    //if isAgent, then always disable

    if (parentGuardian.RelationshipCode === 'AGENT')
      return true;

    if (this.isStudyAbroad) {
      return true;
    }

    return false;
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }
}
